[
 {
  "id": "panel",
  "x": 40,
  "y": 262,
  "w": 860,
  "h": 1166
 }
]